import React, { lazy, Suspense } from 'react';
import { cognitoAuthentication } from 'views/auth/CognitoAuthentication';
import constants from 'helpers/const';
import { LinkedInCallback } from 'react-linkedin-login-oauth2';
import DaoInfo from '../views/pages/app/dao-info';
import DaoDetail from '../views/pages/app/dao/detail';
import DaoList from '../views/pages/app/dao';

const Home = React.lazy(() => import('../views/pages/app/Home'));
const Contact = React.lazy(() => import('../views/pages/app/Contact'));
const Hackathon = React.lazy(() => import('../views/pages/app/Hackathon'));
const TermsOfService = React.lazy(() => import('../views/pages/app/Terms_Of_Service'));
const PrivacyPolicy = React.lazy(() => import('../views/pages/app/Privacy_Policy'));
const Library = React.lazy(() => import('../views/pages/app/Library'));
const FAQ = React.lazy(() => import('../views/pages/app/FAQ'));
const KYC = React.lazy(() => import('../views/pages/app/KYC'));
const KYC_ID = React.lazy(() => import('../views/pages/app/KYC_ID'));
const Presale_Dashboard = React.lazy(() => import('../views/pages/app/Presale_Dashboard'));
const User = React.lazy(() => import('../views/pages/app/user/index'));
const PublicProfile = React.lazy(() => import('../views/pages/app/public-profile'));

//Bounty
const Bounty = React.lazy(() => import('../views/pages/bounty/index'));
const BountyDetail = React.lazy(() => import('../views/pages/bounty/detail'));

const BountyHandleRequest = React.lazy(() => import('../views/pages/bounty/handleRequest'));
const Quiz = React.lazy(() => import('../views/pages/bounty/Quiz'));
const QuizPrevious = React.lazy(() => import('../views/pages/bounty/Quiz/QuizPrevious'));
const TaggingImage = React.lazy(() => import('../views/pages/bounty/TaggingImage'));
const BidMentor = React.lazy(() => import('../views/pages/bounty/Bid'));

//Team
const Team = React.lazy(() => import('../views/pages/team/index'));
const TeamDetail = React.lazy(() => import('../views/pages/team/detail'));
const TeamHandleInvitation = React.lazy(() => import('../views/pages/team/handleInvitation'));
const VoteForFavoriteTeam = React.lazy(() => import('../views/pages/team/voteForFavoriteTeam'));
const VoteForFavoriteTeamV2 = React.lazy(() => import('../views/pages/team/voteForFavoriteTeamV2'));
//Codebase
const Codebase = React.lazy(() => import('../views/pages/codebase/index'));
const CodebaseDetail = React.lazy(() => import('../views/pages/codebase/detail'));

//Payment
const Purchase = React.lazy(() => import('../views/pages/payment/Purchase'));
const CheckoutHandle = React.lazy(() => import('../views/pages/payment/CheckoutHandle'));
const CheckoutHandlePaypal = React.lazy(() => import('../views/pages/payment/CheckoutHandlePaypal'));
const CheckoutSuccess = React.lazy(() => import('../views/pages/payment/CheckoutSuccess'));
const CheckoutFailed = React.lazy(() => import('../views/pages/payment/CheckoutFailed'));
//auth
const Help = React.lazy(() => import('../views/auth/Fail'));
const AuthenticationPage = React.lazy(() => import('../views/auth/AuthenticationPage'));
const SubmissionForm = React.lazy(() => import('../views/pages/bountyMentor/SubmissionForm'));
const ReviewSubmission = React.lazy(() => import('../views/pages/bountyMentor/ReviewSubmission'));
const SaleDetail = React.lazy(() => import('../views/pages/saleBeta/detail'));
const SaleList = React.lazy(() => import('../views/pages/saleBeta/list'));
const Error404 = React.lazy(() => import('../views/pages/test'));

const CodeBase = React.lazy(() => import('../views/pages/codebase2/list'));
const CodeBaseDetail = React.lazy(() => import('../views/pages/codebase2/detail'));
const CodebaseDetail2 = React.lazy(() => import('../views/pages/codebase2/detailChain'));

const EvaluationPublic = React.lazy(() => import('../views/pages/app/evaluation-public'));
const PaymentRequestDetail = React.lazy(() => import('../views/pages/payment-request'));

export default [
  { path: '/', component: Home },
  { path: '/contact', component: Contact },
  { path: '/hackathon', component: Hackathon },
  { path: '/help', component: Help },
  { path: '/faq', component: FAQ },
  { path: '/terms-of-service', component: TermsOfService },
  { path: '/privacy-policy', component: PrivacyPolicy },
  { path: '/library', component: Library },
  { path: '/vagc-vote-for-favorite-team', component: VoteForFavoriteTeam },
  { path: '/vote-for-favorite-team', component: VoteForFavoriteTeam },
  { path: '/vagc-vote-for-grand-finalist-team', component: VoteForFavoriteTeamV2 },
  // { path: "/librarystatic", component: LibraryStatic },
  { path: '/auth', component: cognitoAuthentication(AuthenticationPage) },
  { path: '/kyc-submission', component: cognitoAuthentication(KYC) },
  { path: '/kyc-id-submission', component: cognitoAuthentication(KYC_ID) },
  { path: '/presale-dashboard', component: cognitoAuthentication(Presale_Dashboard) },
  { path: '/user', component: cognitoAuthentication(User) },
  { path: '/user/:page', component: cognitoAuthentication(User) },
  { path: `${constants.PREFIX_PROFILE_PATHNAME}:username`, component: PublicProfile },

  //Bounty - Team
  { path: '/bounty', component: Bounty },
  { path: '/bounty/take-quiz/:bountyId', component: cognitoAuthentication(Quiz) },
  { path: '/bounty/take-previous-quiz/:bountyId', component: cognitoAuthentication(QuizPrevious) },

  // Bounty - Tagging
  { path: '/bounty/bid-mentor', component: cognitoAuthentication(BidMentor) },
  { path: '/bounty/tagging-image/:bountyId', component: cognitoAuthentication(TaggingImage) },

  { path: '/bounty/:bountyId', component: BountyDetail },
  { path: '/contentchallenge', component: BountyDetail },
  { path: '/handle-request', component: BountyHandleRequest },
  // { path: "/gif/researchfunding", component: BountyGif },
  //Team
  { path: '/teams', component: Team },
  { path: '/team/handle-invitation', component: TeamHandleInvitation },
  { path: '/team/:teamId', component: TeamDetail },
  //Codebase
  { path: '/codebase', component: Codebase },
  { path: '/codebase/:codebaseId', component: CodebaseDetail },

  //Evaluation
  { path: '/bounty-mentor/submission', component: cognitoAuthentication(SubmissionForm) },
  { path: '/bounty-mentor/review-submission', component: ReviewSubmission },

  //Payment
  { path: '/purchase', component: cognitoAuthentication(Purchase) },
  { path: '/payment/handle', component: cognitoAuthentication(CheckoutHandle) },
  { path: '/payment/handle-paypal', component: cognitoAuthentication(CheckoutHandlePaypal) },
  { path: '/payment/success', component: cognitoAuthentication(CheckoutSuccess) },
  { path: '/payment/failed', component: cognitoAuthentication(CheckoutFailed) },

  { path: '/quick-evaluation/:token', component: EvaluationPublic },
  { path: '/pay', component: PaymentRequestDetail },

  //Sale
  { path: '/sale/:id', component: SaleDetail },
  { path: '/test', component: Error404 },
  { path: '/token-sale', component: SaleList },

  // Code base
  { path: '/code-base', component: CodeBase },
  // { path: '/code-base/:id', component: CodeBaseDetail },
  { path: '/code-base/:id', component: CodebaseDetail2 },
  // { path: '/code-base-chain/:id', component: CodebaseDetail2 },
  { path: '/linkedin-callback', component: LinkedInCallback },
  {
    path: '/dao',
    component: DaoList,
    exact: true,
    name: 'DAO List',
  },
  {
    path: '/dao/:id',
    component: DaoDetail,
    exact: true,
    name: 'DAO Detail',
  },
];
